import LsBubblesSVG from "@design-system/ui-icons/vanilla/LsBubbles"
import { createIcon } from "../createIcon"

export const LsBubblesIcon = createIcon(LsBubblesSVG)
